import { render, staticRenderFns } from "./ServiceOrdersLG.vue?vue&type=template&id=1cec53d8"
import script from "./ServiceOrdersLG.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersLG.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrdersLG.vue?vue&type=style&index=0&id=1cec53d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports